import {Component, Input} from '@angular/core';
import {WizardType} from '../../wizard-type.enum';

@Component({
  selector: 'app-wizard-profiling',
  imports: [],
  standalone: true,
  templateUrl: './wizard-profiling.component.html'
})
export class WizardProfilingComponent {
  @Input() wizardType: WizardType;
  @Input() description: string;

  protected readonly WizardType = WizardType;
}
